import { NavLink } from "react-router-dom";

import { isURLActive } from "@ui/utils/isURLActive/isURLActive";
import classNames from "classnames";

import { getUrlWithHash } from "@jti/fe-common";

import { LinkElementContent } from "./LinkElementContent";
import type { NavBarElementType } from "./NavBar";

import styles from "./NavBar.module.scss";

export type LinkElementType = {
  link: NavBarElementType;
  isExternal: boolean;
  alwaysExternal: boolean;
};

export function isSubpageActive(link: NavBarElementType): boolean {
  const linkTo = String(link.to);
  return location.hash.indexOf(linkTo) > -1 && linkTo !== "/";
}

export const LinkElement: React.FC<LinkElementType> = ({ link, isExternal, alwaysExternal }) => {
  const activeSubpage = isSubpageActive(link) ? styles.active : "";

  if (isExternal || alwaysExternal) {
    const linkTo = link.to ? `#${link.to as string}` : undefined;
    const url = getUrlWithHash(linkTo, link.external as string);

    return (
      <a
        className={classNames(styles.link, { [styles.active]: isURLActive(url, true) })}
        href={url}
        data-testid={"linkElementExternalLink"}
      >
        <LinkElementContent text={link.text} />
      </a>
    );
  }

  return (
    <NavLink
      className={`${styles.link} ${activeSubpage}`}
      to={link.to as string}
      activeClassName={styles.active}
      exact={true}
    >
      <LinkElementContent text={link.text} />
    </NavLink>
  );
};
